import { render, staticRenderFns } from "./initiated.vue?vue&type=template&id=649a229e"
import script from "./initiated.vue?vue&type=script&lang=js"
export * from "./initiated.vue?vue&type=script&lang=js"
import style0 from "./initiated.vue?vue&type=style&index=0&id=649a229e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports